<template>
  <div class="chart">
    <transition-group class="charts_container" name="charts-list" tag="div" appear>
      <div @click="getChartId(item)" class="square" v-for="item in chartsData" :key="item.id">
        <span class="circle" :class="{'activeChart':activeChart===item.id}"></span>
        <span :class="{'activeChart':activeChart===item.id}"></span>
        <span :class="{'activeChart':activeChart===item.id}"></span>
        <div class="content">
          <h2>{{item.title}}</h2>
        </div>
      </div>
    </transition-group>

    <div class="charts_tracks_container">
      <div class="title_container">
        <transition name="list" appear mode="out-in">
          <span class="chart_title" v-if="chartTracks">{{chartTitle}}</span>
        </transition>
      </div>

      <transition-group v-if="chartTracks" class="top3_tracks" name="list" tag="div" appear>
        <div
          :style="{'transition-delay':`${(index+1)*0.1}s`}"
          :class="{'top3_bg_noborder':activeKKbox===item.id,
          'top3_bg_noborder2':activeYT===item.id}"
          class="top3_bg_border"
          v-for="(item,index) in top3tracks"
          :key="index"
        >
          <span
            :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
          ></span>
          <span
            :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
          ></span>
          <span
            :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
          ></span>
          <span
            :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
          ></span>
          <div class="top3_track_container">
            <div class="top3_rank">{{index+1}}</div>
            <div class="to3_track_txt">
              <div :data-text="item.name" class="top3_track_name">{{item.name}}</div>
              <div class="top3_track_artist">{{item.album.artist.name}}</div>
            </div>
            <!-- BTN -->
            <div class="top3_btn_container">
              <button class="top3_btn_playBtn top3_btn_playYoutube" @click="playYT(item)">
                <i class="fab fa-youtube top3_YT_icon"></i>
              </button>
              <button class="top3_btn_playBtn top3_btn_playKKbox" @click="playKkbox(item)">
                <i class="fab fa-kickstarter top_KK_icon"></i>
              </button>
            </div>
          </div>
        </div>
      </transition-group>

      <transition-group v-if="chartTracks" class="top4to25_tracks" name="list" tag="div" appear>
        <div
          :style="{'transition-delay':`${(index+4)*0.1}s`}"
          :class="{'top3_bg_noborder':activeKKbox===item.id,
          'top3_bg_noborder2':activeYT===item.id}"
          v-for="(item,index) in chart4to25Tracks"
          :key="item.id"
          class="chart_track_container"
          :data-text="index+4"
        >
          <div class="myHover">
            <span
              :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
            ></span>
            <span
              :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
            ></span>
            <span
              :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
            ></span>
            <span
              :class="{
              'active_span_kk':activeKKbox===item.id,
              'active_span_yt':activeYT===item.id}"
            ></span>
            <div class="top4to25_container">
              <h3 class="chart_number_h3">{{index+4}}</h3>
              <h4 :data-text="item.name" class="chart_name_h4">{{item.name}}</h4>
              <h5 class="chart_artist_h5">{{item.album.artist.name}}</h5>
              <button class="top4to25_btn_playBtn top4to25_btn_playYoutube" @click="playYT(item)">
                <i class="fab fa-youtube top4to25_YT_icon"></i>
              </button>
              <button class="top4to25_btn_playBtn top4to25_btn_playKKbox" @click="playKkbox(item)">
                <i class="fab fa-kickstarter top4to25_KK_icon"></i>
              </button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartsData: "",
      chartTracks: "",
      chartTitle: "",
      activeChart: "",
      activeKKbox: "",
      activeYT: "",
      token: "",
      chartId: ""
    };
  },
  computed: {
    // token() {
    //   return this.$store.state.token;
    // },
    chart4to25Tracks() {
      const vm = this;
      let tracks = [];
      vm.chartTracks.forEach(function(track, index) {
        if (tracks.length <= 21 && index > 2) {
          tracks.push(track);
        }
      });
      return tracks;
    },
    top3tracks() {
      const vm = this;
      let tracks = [];
      vm.chartTracks.forEach(function(track) {
        if (tracks.length <= 2) {
          tracks.push(track);
        }
      });
      return tracks;
    }
  },
  methods: {
    getToken() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      const api =
        "https://cors-anywhere.herokuapp.com/https://account.kkbox.com/oauth2/token";
      const config = {
        headers: {
          Accept: "application/x-www-form-urlencoded",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const oauth = {
        grant_type: "client_credentials",
        client_id: "fb254aff20b31017a2e84e34ed896523",
        client_secret: "d2f7853d7a7e2afd98bc4751f1b3c81a"
      };
      vm.$http.post(api, vm.$qs.stringify(oauth), config).then(res => {
        vm.token = res.data.access_token;
        vm.getChartsData();
        vm.$store.dispatch("updateLoading", false);
      });
      // setTimeout(function() {
      //   vm.getChartsData();
      // }, 2000);
    },
    getChartsData() {
      let vm = this;
      const config = {
        headers: {
          Authorization: ` Bearer ${vm.token}`
        }
      };
      this.$http
        .get(`https://api.kkbox.com/v1.1/charts?territory=TW`, config)
        .then(res => {
          vm.chartsData = res.data.data;
        });
    },
    getChartId(item) {
      const vm = this;
      vm.activeChart = item.id;
      vm.chartTracks = "";
      const config = {
        headers: {
          Authorization: ` Bearer ${vm.token}`
        }
      };
      vm.chartId = item.id;
      this.$http
        .get(
          `https://api.kkbox.com/v1.1/charts/${vm.chartId}?territory=TW`,
          config
        )
        .then(res => {
          vm.chartTracks = res.data.tracks.data;
          vm.chartTitle = res.data.title;
        });
    },
    playKkbox(item) {
      const vm = this;
      vm.activeKKbox = "";
      vm.activeYT = "";
      vm.activeKKbox = item.id;
      this.$store.dispatch("playKkbox", item);
    },
    playYT(item) {
      const vm = this;
      vm.activeKKbox = "";
      vm.activeYT = "";
      vm.activeYT = item.id;
      this.$store.dispatch("playYT", item);
    }
  },
  created() {
    this.getToken();
  }
};
</script>

<style scope>
/* @import url("../assets/charts.css"); */
@import url("../assets/charts_test.css");
@import url("../assets/charts_test_RWD.css");

.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
  /* opacity: 1; */
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}

.charts-list-enter-active,
.charts-list-leave-active {
  transition: all 1s;
  /* opacity: 1; */
}
.charts-list-enter, .charts-list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-15px);
}
</style>